// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../views/modules/product-carousel/assets/scss/product-carousel.scss
// module id = 100
// module chunks = 6